/**
 * Formatters del feature colas
 */

/**
 * Formatea una fecha ISO como dd/MM/yyyy HH:mm (es-ES); '-' si es nula o inválida
 */
export const formatFechaHora = (iso) => {
    if (!iso) return "-";
    const fecha = new Date(iso);
    if (Number.isNaN(fecha.getTime())) return "-";
    return fecha.toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });
};
